// extracted by mini-css-extract-plugin
module.exports = {"list":"ResumeContent_list__4u10j"};